import {
	ADD_SPLASH_RESPONSE_SUCCESS,
	DELETE_SPLASH_RESPONSE_SUCCESS,
	EDIT_SPLASH_RESPONSE_SUCCESS,
	SPLASH_REQUEST_GET,
	SPLASH_REQUEST_PATCH,
	SPLASH_REQUEST_POST,
	SPLASH_REQUEST_PUT,
	// PLAN_SELECTED,
	SPLASH_RESPONSE_GET_FAIL,
	SPLASH_RESPONSE_GET_SUCCESS,
	SPLASH_RESPONSE_PATCH_FAIL,
	SPLASH_RESPONSE_POST_FAIL,
	SPLASH_RESPONSE_PUT_FAIL,
} from '../constants/splashpagesConstants';

export const splashListReducer = (state = { splash: {} }, action) => {
	switch (action.type) {
		case SPLASH_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case SPLASH_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				splash: action.payload,
			};
		case SPLASH_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const splashAddReducer = (state = { msg: null, error: null, data:[], loading: false, }, action) => {
	switch (action.type) {
		case SPLASH_REQUEST_POST:
			return {
				...state,
				loading: true,
				error : null
			};
		case SPLASH_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADD_SPLASH_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
	
			
		default:
			return state;
	}
};

export const splashEditReducer = (state = { msg: null, error: null, data:[], loading: false, }, action) => {
	switch (action.type) {
		case SPLASH_REQUEST_PATCH:
			return {
				...state,
				loading: true,
				error : null
			};
		case SPLASH_RESPONSE_PATCH_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case EDIT_SPLASH_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
	
			
		default:
			return state;
	}
};

export const splashDeleteReducer =  (state = { successMessageOnDelete:null, deleteError: null, data:[], loading: false}, action) => {
    switch (action.type) {
      case SPLASH_REQUEST_PUT:		
        return {
          ...state,
          loading: true,
          deleteError : null
        };	
      case SPLASH_RESPONSE_PUT_FAIL:
        return {
          ...state,
          loading: false,
          deleteError: action.payload,
        };
      case DELETE_SPLASH_RESPONSE_SUCCESS:
        return {
          ...state,
          loading: false,
          ...action.payload,
        };
      
      default:
        return state;
    }
  }